module.exports = __webpack_public_path__ + "static/media/private-profile.06867e23.webp";